<div class="flex justify-between content-center">
  <h3 mat-dialog-title data-test-id="expert-transcript-dialog-title">
    {{ expertName }} - Call transcript
  </h3>
  <button
    mat-icon-button
    mat-dialog-close
    data-test-id="expert-transcript-dialog-close-button"
  >
    <mat-icon data-test-id="expert-transcript-dialog-close">clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="flex flex-col">
  @if (transcriptChunks$ | async; as transcriptChunks) {
    <app-transcription-playback
      class="flex flex-col flex-grow min-h-0"
      [transcriptChunks]="transcriptChunks"
      [audioData]="audioData"
      [fileName]="transcriptFile.fileName"
      [audioStartTime]="audioStartTime"
    ></app-transcription-playback>
  } @else {
    <div class="loader-wrapper">
      <app-loader></app-loader>
    </div>
  }
</mat-dialog-content>
